export enum QuestionType {
	Text = 'text',
	Video = 'video',
}
